import MkuSwiper from './src/swiper';

MkuSwiper.install = function (Vue) {
  Vue.component(MkuSwiper.name, MkuSwiper);
};

export default MkuSwiper;
